import css from '../../../../../utils/css';

const styles = css`
  *[class^='Theme_'] {
    --primary-font-family: 'FANtastic-FOX', sans-serif;
    --primary-font-family-condensed: 'FANtastic-FOX-Cond', sans-serif;
    --secondary-font-family: 'ProximaNova', sans-serif;

    --font-family: FANtastic-FOX-Cond;

    --primary-color: #fff;

    --offer-cta-bg-color-hover: #e5e5e5;
    --offer-cta-color: #000;
  }

  *[class^='Text_'] {
    --ts-and-cs-font-size: 0.69em;
    font-family: var(--secondary-font-family);
  }

  *[class^='Cta_'] > button {
    font-family: var(--primary-font-family-condensed);
    font-weight: bold;
  }
`;

export default styles;
